/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Owner_Not_FoundInputs */



/**
* | output |
* | --- |
* | "That user has never signed in here. Ask them to sign in first." |
*
* @param {Tenant_Owner_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const tenant_owner_not_found = /** @type {((inputs?: Tenant_Owner_Not_FoundInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Owner_Not_FoundInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Этот человек здесь ещё не входил. Попросите его сначала войти.")
	return /** @type {LocalizedString} */ ("That user has never signed in here. Ask them to sign in first.")
});